import { render, staticRenderFns } from "./DashboardDetailFinished.vue?vue&type=template&id=98839ef0&scoped=true&"
import script from "./DashboardDetailFinished.vue?vue&type=script&lang=js&"
export * from "./DashboardDetailFinished.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98839ef0",
  null
  
)

export default component.exports